module.exports = __webpack_public_path__ + "static/media/one.cc9a4338.jpg";